(() => {
  const initialize = () => {
    const config = document.querySelector('[data-as-menu-cards-config]');
    const drawer = document.getElementById('menu-drawer');
    const root = drawer?.querySelector('.menu-drawer__navigation > ul');
    if (!config || !root) return;
    // Reinitialization in the theme editor replaces only this feature's additions.
    root.querySelectorAll(':scope > .as-menu-home, :scope > .as-menu-promo').forEach(el => el.remove());
    drawer.classList.add('as-menu-cards');
    const footerColor = getComputedStyle(document.querySelector('footer.footer') || document.body).backgroundColor;
    const rgb = footerColor.match(/[\d.]+/g)?.slice(0, 3).map(Number);
    if (rgb?.length === 3) {
      const previous = rgb.map(c => Math.round(c * 0.7 + 255 * 0.3));
      // Brighten 30% toward white, then reduce HSL saturation by 20%.
      const brighter = previous.map(c => c * 0.7 + 255 * 0.3);
      const lightness = (Math.max(...brighter) + Math.min(...brighter)) / 2;
      const background = brighter.map(c => Math.round(lightness + (c - lightness) * 0.8));
      drawer.style.setProperty('--as-menu-card-background', `rgb(${background.join(', ')})`);
    }
    // Dispose observers/listeners when a section is reloaded in the editor.
    drawer.asMenuCardsCleanup?.();
    const controller = new AbortController();
    let scheduled = false;
    const updateViewport = () => {
      scheduled = false;
      const viewport = window.visualViewport;
      let bottom = Math.min(window.innerHeight, (viewport?.offsetTop || 0) + (viewport?.height || window.innerHeight));
      const preview = document.getElementById('PBarNextFrameWrapper');
      if (preview && getComputedStyle(preview).display !== 'none') {
        const rect = preview.getBoundingClientRect();
        if (rect.height > 0 && rect.top < bottom && rect.bottom > 0) bottom = Math.min(bottom, Math.max(0, rect.top));
      }
      drawer.style.setProperty('--as-menu-visible-bottom', `${bottom}px`);
    };
    const scheduleViewport = () => {
      if (!scheduled) { scheduled = true; requestAnimationFrame(updateViewport); }
    };
    const sizes = new ResizeObserver(scheduleViewport);
    sizes.observe(document.documentElement);
    let previewElement = null;
    const watchPreview = () => {
      const next = document.getElementById('PBarNextFrameWrapper');
      if (previewElement === next) return;
      if (previewElement) sizes.unobserve(previewElement);
      previewElement = next;
      if (previewElement) sizes.observe(previewElement);
      scheduleViewport();
    };
    const nodes = new MutationObserver(watchPreview);
    nodes.observe(document.body, {childList: true});
    const previewChanges = new MutationObserver(scheduleViewport);
    // Shopify hides, collapses or repositions the preview wrapper in place.
    const watchPreviewAttributes = () => {
      previewChanges.disconnect();
      if (previewElement) previewChanges.observe(previewElement, {attributes: true, attributeFilter: ['style', 'hidden', 'class']});
    };
    const previewNodes = new MutationObserver(watchPreviewAttributes);
    previewNodes.observe(document.body, {childList: true});
    watchPreview(); watchPreviewAttributes();
    window.addEventListener('resize', scheduleViewport, {signal: controller.signal});
    window.visualViewport?.addEventListener('resize', scheduleViewport, {signal: controller.signal});
    window.visualViewport?.addEventListener('scroll', scheduleViewport, {signal: controller.signal});
    document.getElementById('Details-menu-drawer-container')?.addEventListener('toggle', scheduleViewport, {signal: controller.signal});
    drawer.asMenuCardsCleanup = () => { controller.abort(); sizes.disconnect(); nodes.disconnect(); previewNodes.disconnect(); previewChanges.disconnect(); };
    updateViewport();
    root.classList.add('as-menu-root');
    const decorateSubmenus = () => {
      drawer.querySelectorAll('.menu-drawer__submenu').forEach(panel => {
        const container = panel.querySelector(':scope > .menu-drawer__inner-submenu') || panel;
        const back = container.querySelector(':scope > .menu-drawer__close-button');
        const list = container.querySelector(':scope > ul.menu-drawer__menu');
        if (!back || !list) return;
        // These existing helpers own the Kids and SALE groups and destinations.
        if (panel.id === 'link-kids-formal-dresses' && list.dataset.customKidsAgeMenu !== 'true') return;
        if (panel.id === 'link-sale' && !list.classList.contains('custom-mobile-sale-menu-v1')) return;
        const panelTitle = back.textContent.trim();
        back.setAttribute('aria-label', panel.id.startsWith('childlink-') ? 'Back to previous menu' : 'Back to main menu');
        list.classList.add('as-submenu-list');
        const headings = [...list.children].filter(li => !li.querySelector('a, summary, button'));
        if (!headings.length) {
          const heading = document.createElement('li');
          heading.className = 'as-submenu-heading';
          heading.setAttribute('role', 'presentation');
          heading.textContent = panelTitle;
          list.prepend(heading);
        } else headings.forEach(heading => heading.classList.add('as-submenu-heading'));
        list.querySelectorAll('.menu-drawer__menu-item').forEach(control => {
          if (control.classList.contains('as-submenu-row')) return;
          const label = document.createElement('span');
          label.className = 'as-submenu-label';
          [...control.childNodes].filter(node => node.nodeType === Node.TEXT_NODE).forEach(node => label.append(node));
          control.prepend(label);
          control.classList.add('as-submenu-row');
          control.closest('li')?.classList.add('as-submenu-item');
        });
      });
    };
    decorateSubmenus();
    // Existing group helpers can populate their menus later during section loading.
    const submenuUpdates = new MutationObserver(decorateSubmenus);
    submenuUpdates.observe(root, {childList: true, subtree: true});
    const submenuCleanup = drawer.asMenuCardsCleanup;
    drawer.asMenuCardsCleanup = () => { submenuUpdates.disconnect(); submenuCleanup(); };
    const photos = JSON.parse(config.querySelector('[data-as-menu-card-images]').textContent);
    const pendingPhotos = new Map();
    [...root.children].forEach(li => {
      const control = li.querySelector(':scope > a, :scope > details > summary');
      if (!control) return;
      control.classList.add('as-menu-card');
      if (!control.querySelector('.as-menu-card__label')) {
        const label = document.createElement('span');
        label.className = 'as-menu-card__label';
        [...control.childNodes].filter(n => n.nodeType === Node.TEXT_NODE).forEach(n => label.append(n));
        control.prepend(label);
      }
      control.querySelectorAll('.as-menu-card__photo').forEach(img => img.remove());
      const photo = photos.find(p => `HeaderDrawer-${p.id}` === control.id);
      control.classList.toggle('as-menu-card--photo', !!photo?.image);
      if (photo?.image) pendingPhotos.set(control, {url: photo.image, visible: false});
    });
    // Load each static photo once, only when its mobile menu card is visible.
    const mobile = matchMedia('(max-width: 989px)');
    const mainDetails = document.getElementById('Details-menu-drawer-container');
    const loadVisiblePhotos = () => {
      if (!mobile.matches || !mainDetails?.open ||
          !mainDetails.classList.contains('menu-opening') || root.classList.contains('submenu-open')) return;
      pendingPhotos.forEach((photo, control) => {
        if (!photo.visible) return;
        pendingPhotos.delete(control);
        photoVisibility.unobserve(control);
        const img = new Image();
        img.className = 'as-menu-card__photo'; img.alt = ''; img.decoding = 'async';
        img.onerror = () => { img.remove(); control.classList.remove('as-menu-card--photo'); };
        img.src = photo.url;
        control.append(img);
      });
      if (!pendingPhotos.size) {
        photoVisibility.disconnect();
        photoMenuChanges.disconnect();
      }
    };
    const photoVisibility = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const photo = pendingPhotos.get(entry.target);
        if (photo) photo.visible = entry.isIntersecting;
      });
      loadVisiblePhotos();
    }, {root: drawer.querySelector('.menu-drawer__navigation-container'), threshold: 0.01});
    pendingPhotos.forEach((photo, control) => photoVisibility.observe(control));
    const photoMenuChanges = new MutationObserver(loadVisiblePhotos);
    photoMenuChanges.observe(root, {attributes: true, attributeFilter: ['class']});
    if (mainDetails) photoMenuChanges.observe(mainDetails, {attributes: true, attributeFilter: ['class', 'open']});
    mobile.addEventListener('change', loadVisiblePhotos, {signal: controller.signal});
    const viewportCleanup = drawer.asMenuCardsCleanup;
    drawer.asMenuCardsCleanup = () => {
      photoVisibility.disconnect(); photoMenuChanges.disconnect();
      viewportCleanup();
    };

    const payLess = root.querySelector('#HeaderDrawer-pay-less-celebrate-more')?.closest('li');
    const promo = config.querySelector('[data-as-menu-promo]').content.cloneNode(true);
    payLess?.classList.add('as-menu-legacy-benefits');
    root.prepend(promo);
    const carousel = root.querySelector('.as-menu-carousel');
    const loadHighlightPhotos = () => {
      if (!mobile.matches || !mainDetails?.open) return;
      carousel.querySelectorAll('img[data-as-menu-highlight-src]').forEach(img => {
        img.src = img.dataset.asMenuHighlightSrc;
        img.removeAttribute('data-as-menu-highlight-src');
      });
    };
    mainDetails?.addEventListener('toggle', loadHighlightPhotos, {signal: controller.signal});
    mobile.addEventListener('change', loadHighlightPhotos, {signal: controller.signal});
    loadHighlightPhotos();
    const track = carousel.querySelector('.as-menu-carousel__track');
    const buttons = [...carousel.querySelectorAll('[data-as-slide]')];
    const syncDots = () => {
      const index = Math.round(track.scrollLeft / (track.clientWidth || 1));
      buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    };
    buttons.forEach((button, i) => button.addEventListener('click', () => {
      track.scrollTo({left: track.clientWidth * i, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }));
    track.addEventListener('scroll', syncDots, {passive: true});
    track.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      const next = Math.max(0, Math.min(buttons.length - 1, Math.round(track.scrollLeft / track.clientWidth) + (event.key === 'ArrowRight' ? 1 : -1)));
      buttons[next]?.click();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
